module.exports = __webpack_public_path__ + "img/bri.a208ab3b.png";